const DetalheCronogramaAprovacao = () => import('./DetalheCronogramaAprovacao.vue')

export default {
    path: 'cronogramas',
    name: 'Cronogramas',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        {
            path: ':contratoId',
            name: 'DetalheCronogramaAprovacao',
            component: DetalheCronogramaAprovacao
        }
    ]
}
